import { useEffect, useState } from "react";

import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { ReadOnlyTextProperty } from "@/components/doc/right-sidebar/node-viewer/NodeProperty";
import { NodePropertyInput } from "@/components/doc/right-sidebar/node-viewer/NodePropertyInput";
import { type ViewerNode } from "@/components/doc/right-sidebar/node-viewer/types";
import { setNodeName } from "@/components/doc/right-sidebar/node-viewer/utils";
import { isNodeEditable } from "@/components/tiptap/lock/utils";

type Props = {
  node: ViewerNode;
};

const NodeNamePropertyField = observer(function NodeNamePropertyField({ node }: Props) {
  const t = useTranslations("sidebar");
  const [name, setName] = useState(() => node.name);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = e.target;
    setName(newValue);
    setNodeName(node, newValue);
  };

  useEffect(() => {
    setName(node.name);
  }, [node.name]);

  return (
    <NodePropertyInput
      id="name"
      value={name}
      label={t("nodeProps.nodeName")}
      onChange={handleNameChange}
    />
  );
});

const NodeNamePropertyReadOnly = observer(function NodeNamePropertyReadOnly({ node }: Props) {
  const t = useTranslations("sidebar");

  return <ReadOnlyTextProperty name={t("nodeProps.nodeName")} value={node.name ?? ""} />;
});

export const NodeNameProperty = observer(function NodeNameProperty(props: Props) {
  if (!isNodeEditable(props.node)) {
    return <NodeNamePropertyReadOnly {...props} />;
  }

  return <NodeNamePropertyField {...props} />;
});
